export default __webpack_public_path__ + "static/media/22.33cec3e6.jpg";